import React from "react";
import vCardsJS from "vcards-js";
import axios from "axios";
import { Buffer } from 'buffer';

export default function SaveContact(props) {
  const downloadTxtFile = (vcfText) => {
    console.log('downloadTxtFile');

    try {
    const base64Data = Buffer.from(vcfText, 'utf-8').toString('base64');
    const dataUrl = `data:text/vcard;base64,${base64Data}`;

    const element = document.createElement("a");
    element.href = dataUrl;
    element.download = "myContact.vcf";

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  } catch (error) {
      console.log('error ====> error');
  }
  };

  const getBase64FromUrl = async (url) => {
    const { data } = await axios({
      method: "GET",
      url,
      responseType: "blob",
    });

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = () => {
        const base64data = reader.result.split(",")[1];
        resolve(base64data);
      };
    });
  };

  const CreateVCard = async () => {
    console.log('CreateVCardCreateVCard');

    try {
    const vCard = vCardsJS();
    vCard.version = '3.0'
    let fullName = props.data.fullName;
    let company = ''
    //  props.data?.company;
    let department = ''
    //  props.data?.department;

    vCard.firstName = fullName;

    vCard.organization = company;
    // Set first email as primary
    if (props.data?.email?.[0]?.link) {
      vCard.email = props.data.email[0].link;
    }
    // Set first phone number as primary
    if (props.data?.mobileNumber?.[0]?.link) {
      vCard.workPhone = props.data.mobileNumber[0].link;
    }
    vCard.title = department;
    // Set first website as primary
    if (props.data?.website?.[0]?.link) {
      vCard.url = props.data.website[0].link;
    }

    try {
      const base64Img = await getBase64FromUrl(props.data.mainUserImg);
      vCard.photo.embedFromString(base64Img, "JPEG");
    } catch (error) {
      console.error("Error embedding the image", error);
    }

    // Get the formatted vCard string
    let vcfText = vCard.getFormattedString();

    // Detect iOS to avoid duplicate social media links
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // Arrays to store additional fields
    const additionalPhones = [];
    const additionalEmails = [];
    const additionalUrls = [];
    const socialProfiles = [];
    const socialUrls = [];

    // Add all phone numbers (skip first one as it's already added)
    if (props.data?.mobileNumber && Array.isArray(props.data.mobileNumber)) {
      props.data.mobileNumber.forEach((phone, index) => {
        if (phone?.link && index > 0) { // Skip first one (already added as workPhone)
          additionalPhones.push(`TEL;TYPE=CELL:${phone.link}`);
        }
      });
    }

    // Add all emails (skip first one as it's already added)
    if (props.data?.email && Array.isArray(props.data.email)) {
      props.data.email.forEach((email, index) => {
        if (email?.link && index > 0) { // Skip first one (already added)
          additionalEmails.push(`EMAIL;TYPE=INTERNET:${email.link}`);
        }
      });
    }

    // Add all websites (skip first one as it's already added)
    if (props.data?.website && Array.isArray(props.data.website)) {
      props.data.website.forEach((website, index) => {
        if (website?.link && index > 0) { // Skip first one (already added)
          additionalUrls.push(`URL;TYPE=website:${website.link}`);
        }
      });

    }

    // Add all Facebook links
    if (props.data?.facebook && Array.isArray(props.data.facebook)) {
      props.data.facebook.forEach((fb) => {
        if (fb?.link) {
          socialProfiles.push(`X-SOCIALPROFILE;TYPE=facebook:${fb.link}`);
          // Only add URL format for Android (not iOS) to avoid duplicates
          if (!isIOS) {
            socialUrls.push(`URL;TYPE=facebook:${fb.link}`);
          }
        }
      });
    }

    // Add all Instagram links
    if (props.data?.instgram && Array.isArray(props.data.instgram)) {
      props.data.instgram.forEach((ig) => {
        if (ig?.link) {
          socialProfiles.push(`X-SOCIALPROFILE;TYPE=instagram:${ig.link}`);
          if (!isIOS) {
            socialUrls.push(`URL;TYPE=instagram:${ig.link}`);
          }
        }
      });
    }

    // Add all LinkedIn links
    if (props.data?.linkedIn && Array.isArray(props.data.linkedIn)) {
      props.data.linkedIn.forEach((li) => {
        if (li?.link) {
          socialProfiles.push(`X-SOCIALPROFILE;TYPE=linkedin:${li.link}`);
          if (!isIOS) {
            socialUrls.push(`URL;TYPE=linkedin:${li.link}`);
          }
        }
      });
    }

    // Add all Snapchat links
    if (props.data?.snapChat && Array.isArray(props.data.snapChat)) {
      props.data.snapChat.forEach((sc) => {
        if (sc?.link) {
          socialProfiles.push(`X-SOCIALPROFILE;TYPE=snapchat:${sc.link}`);
          if (!isIOS) {
            socialUrls.push(`URL;TYPE=snapchat:${sc.link}`);
          }
        }
      });
    }

    // Add all WhatsApp links
    if (props.data?.whatsApp && Array.isArray(props.data.whatsApp)) {
      props.data.whatsApp.forEach((wa) => {
        if (wa?.link) {
          socialProfiles.push(`X-SOCIALPROFILE;TYPE=whatsapp:${wa.link}`);
          if (!isIOS) {
            socialUrls.push(`URL;TYPE=whatsapp:${wa.link}`);
          }
        }
      });
    }

    // Add all Telegram links
    if (props.data?.telegram && Array.isArray(props.data.telegram)) {
      props.data.telegram.forEach((tg) => {
        if (tg?.link) {
          socialProfiles.push(`X-SOCIALPROFILE;TYPE=telegram:${tg.link}`);
          if (!isIOS) {
            socialUrls.push(`URL;TYPE=telegram:${tg.link}`);
          }
        }
      });
    }

    // Add all X (Twitter) links
    if (props.data?.twiter && Array.isArray(props.data.twiter)) {
      props.data.twiter.forEach((tw) => {
        if (tw?.link) {
          socialProfiles.push(`X-SOCIALPROFILE;TYPE=twitter:${tw.link}`);
          if (!isIOS) {
            socialUrls.push(`URL;TYPE=twitter:${tw.link}`);
          }
        }
      });
    }

    // Add all TikTok links
    if (props.data?.tikTok && Array.isArray(props.data.tikTok)) {
      props.data.tikTok.forEach((tt) => {
        if (tt?.link) {
          socialProfiles.push(`X-SOCIALPROFILE;TYPE=tiktok:${tt.link}`);
          if (!isIOS) {
            socialUrls.push(`URL;TYPE=tiktok:${tt.link}`);
          }
        }
      });
    }

    // Combine all additional fields
    const allAdditionalFields = [
      ...additionalPhones,
      ...additionalEmails,
      ...additionalUrls,
      ...socialProfiles,
      ...socialUrls
    ];

    // Append all additional fields before END:VCARD
    // iOS: Only X-SOCIALPROFILE (to avoid duplicates)
    // Android: Both X-SOCIALPROFILE and URL (for maximum compatibility)
    if (allAdditionalFields.length > 0) {
      const fieldsString = allAdditionalFields.join('\r\n');
      // Remove END:VCARD, add additional fields, then add END:VCARD back
      // Handle both \r\n (Windows) and \n (Unix) line endings
      vcfText = vcfText.replace(/(\r?\n)END:VCARD(\r?\n)?$/i,
        '\r\n' + fieldsString + '\r\nEND:VCARD\r\n');
    }
console.log('vcfText=======>',vcfText);

    return vcfText;

  } catch (error) {
      console.log('error 11 =======>',error);

  }
  };

  return (
    <button
      style={{ backgroundColor: props.color }}
      onClick={async () => downloadTxtFile(await CreateVCard())}
      className="save-button"
    >
      SAVE CONTACT
    </button>
  );
}
